<div class="product-actions">

  <div class="product-actions-wrapper"
       *ngIf="isExpanded else startActionTemplate"
       fxLayout="row"
       fxLayoutAlign="space-between center">

    <!---->
    <button class="btn-icon decrease"
            (click)="onDecrease()">
      <mat-icon>{{decraseBtnClassName}}</mat-icon>
    </button>


    <!--      -->
    <div fxLayout="row" class="product-ticket-quantity-text">
      <span>{{quantity}}</span>
      <span>{{'shared.labels.piece'|translate}}</span>
    </div>

    <!--      -->
    <button class="btn-icon increase"
            [class.disable]="disabled"
            (click)="onIncrease()">
      <mat-icon>add</mat-icon>
    </button>


  </div>
</div>

<ng-template #startActionTemplate>
  <button mat-button class="small-button"
          color="primary"
          [class.disable]="disabled"
          [ngClass]="buttonClassName"
          [disabled]="disabled"
          (click)="onIncrease()">{{label|translate}}
  </button>
</ng-template>
